
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import SelectModal from '../../selectmodal/selectmodal.controller';
import { ListItem } from '../../backend/backendapi';

@Component({
  components: {
    SelectModal: require('../../selectmodal/selectmodal.vue.html').default,
  },
})
export default class UsersSelectModal extends Vue {
  @Prop({ required: true })
  readonly allUsers!: ListItem[];

  private selectedUsers: ListItem[] = [];

  public open(): void {
    this.selectedUsers.splice(0);
    (this.$refs.selectModal as SelectModal<ListItem>).open();
  }

  public dismiss(): void {
    (this.$refs.selectModal as SelectModal<ListItem>).dismiss();
  }

  formatUserName(user: ListItem): string {
    return (user.firstName ?? '') + ' ' + (user.lastName ?? '');
  }

  onAddUser(entry: ListItem): void {
    this.selectedUsers.push(entry);
  }

  onRemoveUser(entry: ListItem): void {
    const index = this.selectedUsers.findIndex(e => e.id === entry.id);
    if (index >= 0) {
      this.selectedUsers.splice(index, 1);
    }
  }
}
